// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#debugMenu[data-v-1cb6701e]{background-color:#0f6674;width:20px;height:20px}#debugMenu button[data-v-1cb6701e],#debugMenu p[data-v-1cb6701e]{display:none}#debugMenu[data-v-1cb6701e]:hover{width:200px;height:200px}#debugMenu:hover button[data-v-1cb6701e],#debugMenu:hover p[data-v-1cb6701e]{display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
